import gql from 'graphql-tag';

export const canAccessCropPlanningQuery = gql`
  query canAccessCropPlanning($userId: ID) {
    canAccessCropPlanning(userId: $userId)
  }
`;
